export default {
  locationExpired: 'Location expirée',
  timeLeft: 'Reste {time} min' // time is in minutes
}
